import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ParagraphSectionComponent } from '../paragraph-section/paragraph-section.component';
import { InfoSectionComponent } from '../info-section/info-section.component';
import { PictureSectionComponent } from '../picture-section/picture-section.component';
import { TitleSectionComponent } from '../title-section/title-section.component';
import { InstagramSectionComponent } from '../instagram-section/instagram-section.component';
import { MentionSectionComponent } from '../mention-section/mention-section.component';
import { ArticleLinkSectionComponent } from '../article-link/article-link-section.component';
import { IframeSectionComponent } from '../iframe-section/iframe-section.component';
import { ButtonSectionComponent } from '../button-section/button-section.component';

@Component({
    selector: 'admin-section',
    templateUrl: './section.component.html',
    styleUrls: ['./section.component.scss'],
    imports: [
        CommonModule,
        ParagraphSectionComponent,
        InfoSectionComponent,
        PictureSectionComponent,
        TitleSectionComponent,
        InstagramSectionComponent,
        MentionSectionComponent,
        ArticleLinkSectionComponent,
        IframeSectionComponent,
        ButtonSectionComponent
    ]
})
export class SectionComponent implements OnInit {
  @Input() componentName: string;
  @Input() sectionData: any;
  @Output() sectionDataChange = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}
}
